import React from "react";
import { useLocation } from "react-router-dom";
import { MenuModel } from "../../types";
import { findActiveMenuKeyInSections } from "../../utils/menuNavigation";
import AppSidebarSection from "./AppSidebarSection";

type AppSidebarMenuProps = {
    model: MenuModel[];
};

const AppSidebarMenu = ({ model }: AppSidebarMenuProps) => {
    const { pathname } = useLocation();
    const activeMenuKey = findActiveMenuKeyInSections(model, pathname);

    return (
        <nav className="app-sidebar-nav" aria-label="Main navigation">
            <div className="app-sidebar-sections">
                {model.map((section, index) => (
                    <AppSidebarSection
                        key={section.key ?? index}
                        section={section}
                        sectionIndex={index}
                        activeMenuKey={activeMenuKey}
                    />
                ))}
            </div>
        </nav>
    );
};

export default AppSidebarMenu;
